export type TNativeAudioParam = AudioParam;
